import {createContext} from 'react'

const removeItem = (state, uuid) => {
  const items = {...state.items}
  delete items[uuid]
  return {...state, items: items}
}

export const cartReducer = (state, action) => {
  const result = handleAction(state, action)
  localStorage.setItem('cart', JSON.stringify(result.items))
  return result
}

const handleAction = (state, action) => {
  switch (action.type) {
    case 'add':
      return {...state, items: {...state.items, [action.payload.uuid]: {count: 1, price: action.payload.price, data: action.payload.data}}}
    case 'increment':
      const newState = {...state}
      newState.items[action.payload.uuid].count += action.payload.amount
      return newState
    case 'decrement':
      if (state.items[action.payload.uuid].count > action.payload.amount) {
        const newState = {...state}
        newState.items[action.payload.uuid].count -= action.payload.amount
        return newState
      } else {
        return removeItem(state, action.payload.uuid)
      }
    case 'remove':
      return removeItem(state, action.payload)
    case 'reset':
      return defaultCart
    default:
      return state
  }
}

export const defaultCart = {
  items: {},
}

export default createContext({
  cart: defaultCart,
  cartDispatch: null,
  cartVisible: false,
  setCartVisible: () => {},
})
